import withUniqueId from 'ia-react-core/~/hocs/helpers/_withUniqueId/withUniqueId';
import withSchema from 'ia-react-core/~/hocs/schema/withSchema';
import injectTranslations from 'ia-react-core/~/hocs/translation/injectTranslations';
import compose from '../../../utils/components/_compose';

import fr from './translations/fr';
import en from './translations/en';

import NavigationGuard from './NavigationGuard';

export * from './NavigationGuard';

export default compose<typeof NavigationGuard>(
  withUniqueId('modalId', { acceptOverride: true }),
  withSchema('modal'),
  injectTranslations('Core.NavigationGuard', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
)(NavigationGuard);
